import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { getIcon } from '../get-icon'

interface IChipConnectorTextProps {
  name: string
  type: string
}

const styles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.3rem',
    padding: 0,

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },

    '& svg': {
      fill: theme.palette.primary.main,
    },
  },
}))

const ChipConnectorText: React.FC<IChipConnectorTextProps> = ({ name, type }) => {
  const classes = styles()

  return (
    <span className={classes.root}>
      {getIcon(name)}
      {name}
    </span>
  )
}

export default ChipConnectorText
